import { render, staticRenderFns } from "./FilterInvest.vue?vue&type=template&id=db168220&"
import script from "./FilterInvest.vue?vue&type=script&lang=js&"
export * from "./FilterInvest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports